import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CROP_FIELDS_AND_WORKS_INDEX } from '../../../router/routes';
import Field from '../../../interfaces/field';
import Title from '../../../components/common/title';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
  useTab,
} from '../../../components/common/tabs/tab-container';
import FieldListMap from './fields/components/field-list-map';
import ShowIfAllowed from '../../../components/common/show-if-allowed';
import { SelectedRowsProvider } from '../../../components/common/table/selected-rows-context';
import Fields from './fields';
import WorkOverview from './work-overview';
import css from './index.module.css';

export enum Section {
  fields = 'fields',
  workOverview = 'work-overview',
}

export default function FieldsAndWorks() {
  const { t } = useTranslation();
  const [currentTab, setTab] = useTab(CROP_FIELDS_AND_WORKS_INDEX, [
    'tab',
    'farmId',
    'season',
  ]);
  const [showFullSize, setShowFullSize] = useState(false);
  const [showFilter, setShowFilter] = useState(true);

  return (
    <div
      className={`${css['container']} ${
        currentTab === Section.fields ? css['show-map-index'] : ''
      } ${showFullSize ? css['opened'] : ''}`}
    >
      <SelectedRowsProvider<Field>>
        <Title title={t('pages.crop.fields_and_works.title')} />
        <TabContainer
          selectedTabKey={currentTab}
          setTab={setTab}
          tabNavigation={
            <TabNavigation>
              <ShowIfAllowed ability={{ entity_type: 'field' }}>
                <TabLink tabKey={Section.fields}>
                  {t('pages.crop.fields_and_works.fields.title')}
                </TabLink>
              </ShowIfAllowed>
              <ShowIfAllowed ability={{ entity_type: 'work' }}>
                <TabLink tabKey={Section.workOverview}>
                  {t('pages.crop.fields_and_works.work-overview.title')}
                </TabLink>
              </ShowIfAllowed>
            </TabNavigation>
          }
          tabContents={
            <TabContents>
              <ShowIfAllowed ability={{ entity_type: 'field' }}>
                <Tab tabKey={Section.fields}>
                  <Fields
                    setShowFilter={setShowFilter}
                    showFilter={showFilter}
                  />
                </Tab>
              </ShowIfAllowed>
              <ShowIfAllowed ability={{ entity_type: 'work' }}>
                <Tab tabKey={Section.workOverview}>
                  <WorkOverview />
                </Tab>
              </ShowIfAllowed>
            </TabContents>
          }
        />

        {currentTab === Section.fields ? (
          <ShowIfAllowed
            ability={{ entity_type: 'field' }}
            key="field-list-map"
          >
            <FieldListMap
              setShowFullSize={setShowFullSize}
              showFullSize={showFullSize}
              showFilter={showFilter}
            />
          </ShowIfAllowed>
        ) : (
          ''
        )}
      </SelectedRowsProvider>
    </div>
  );
}
